import { IBlockedEmailDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('blocked-emails');

export const getBlockedEmailsAction = actionCreator.async<undefined, IBlockedEmailDto[]>(
	constants.GET_BLOCKED_EMAILS
);

export const unblockEmailAction = actionCreator.async<string, void>(
	constants.UNBLOCK_EMAIL
);
